import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

interface agGridDataPair {
  rows: any[];
  columns: any[];
  identifier: string;
}

export interface agGridExtraData {
  value: string;
  columnSize: number;
}

interface CustomAgGridTableProps {
  title: string;
  tableData: agGridDataPair;
  rowClassRules?: any;
  customCellStyle: { field: string; cellStyle: any };
  extraTableData?: agGridExtraData[];
  containerStyle?: any;
  suppressHorizontalScroll?: boolean;
  height?: any;
  domLayout?: "normal" | "autoHeight" | "print";
}

export const CustomAgGridTable = (props: CustomAgGridTableProps) => {
  const cellStyleFinal = props.customCellStyle.cellStyle;
  cellStyleFinal["textAlign"] = "center";

  const generateExtraTableDataColumns = () => {
    var extraTableColumns: any = [];
    var blankColumn: string = " ";

    if (typeof props.extraTableData !== "undefined") {
      props.extraTableData?.forEach((element) => {
        extraTableColumns.push({
          field: blankColumn,
          maxWidth: element.columnSize,
        });
        blankColumn = blankColumn + " ".repeat(1);
      });
    }

    return extraTableColumns;
  };

  const generateExtraTableDataRows = () => {
    var extraTableRows: any = {};
    var blankColumn: string = " ";

    if (typeof props.extraTableData !== "undefined") {
      for (var i = 0; i < props.extraTableData!.length; i++) {
        extraTableRows[blankColumn] = props.extraTableData![i].value;
        blankColumn = blankColumn + " ".repeat(1);
      }
    }

    return [extraTableRows];
  };

  return (
    <div
      className="save-to-pdf"
      style={{
        padding: 5,
        borderTop: 0,
        borderBottom: 0,
        borderLeft: 1,
        borderRight: 1,
        borderStyle: "solid",
        ...props.containerStyle,
      }}
    >
      <div className="table-title">{props.title}</div>
      <div style={{ paddingBottom: 5 }}>
        <div
          className="ag-theme-quartz"
          style={{
            height: props.height ?? "100%",
            "--ag-header-background-color": "transparent",
            "--ag-border-color": "transparent",
            "--ag-row-border-color": "transparent",
            "--ag-header-column-separator-display": "none",
            "--ag-wrapper-border-radius": "0px",
            "--ag-border-radius": "0px",
            "--ag-header-cell-hover-background-color": "transparent",
            "--ag-header-column-resize-handle-display": "none",
            "--ag-cell-horizontal-border": "none",
            "--ag-header-cell-moving-background-color": "transparent",
            "--ag-cell-vertical-padding": "0px",
            "--ag-row-hover-color": "transparent",
            "--ag-row-height": "32px",
          } as React.CSSProperties}
        >
          <AgGridReact
            rowHeight={32}
            suppressHorizontalScroll={props.suppressHorizontalScroll}
            className="custom-ag-container"
            domLayout={props.domLayout ?? "autoHeight"}
            defaultColDef={{
              cellClass: "text",
              headerClass: "column",
              resizable: false,
              cellStyle: cellStyleFinal,
              sortable: false
            }}
            rowClassRules={props.rowClassRules}
            rowData={props.tableData.rows}
            columnDefs={props.tableData.columns}
            suppressFieldDotNotation={true}
            suppressMovableColumns={true}
            suppressCellFocus={true}
          />
        </div>
      </div>
      <div
        style={{
          display:
            typeof props.extraTableData !== "undefined" ? "block" : "none",
        }}
      >
        <div
          className="ag-theme-quartz"
          style={{
            "--ag-header-background-color": "transparent",
            "--ag-border-color": "transparent",
            "--ag-row-border-color": "transparent",
            "--ag-header-column-separator-display": "none",
            "--ag-wrapper-border-radius": "0px",
            "--ag-border-radius": "0px",
            "--ag-header-cell-hover-background-color": "transparent",
            "--ag-header-column-resize-handle-display": "none",
            "--ag-cell-horizontal-border": "none",
            "--ag-header-cell-moving-background-color": "transparent",
            "--ag-row-hover-color": "transparent",
          } as React.CSSProperties}
        >
          <AgGridReact
            domLayout={"print"}
            rowHeight={32}
            defaultColDef={{
              cellClass: "text",
              headerClass: "column",
              resizable: false,
              cellStyle: { textAlign: "center" },
              sortable: false
            }}
            rowClassRules={{
              "table-total": function (params: any) {
                return true;
              },
            }}
            rowData={generateExtraTableDataRows()}
            columnDefs={generateExtraTableDataColumns()}
            suppressMovableColumns={true}
            suppressCellFocus={true}
          />
        </div>
      </div>
    </div>
  );
};